// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"765":"6b32ab20","787":"0069a938"}[chunkId] + ".chunk.js";
};